import {red, common} from "@material-ui/core/colors";
import {createMuiTheme} from "@material-ui/core/styles";

// A custom theme for this app
const theme = createMuiTheme({
  palette: {
    primary: {
      main: common.black,
    },
    secondary: {
      main: "#DE2D47",
    },
    error: {
      main: red.A400,
    },
    background: {
      default: "#fff",
    },
  },
});

export default theme;
